<template>
  <div class="wrapper">
    <Navbar></Navbar>
    <Sidebar></Sidebar>

    <router-view></router-view>
  </div>
</template>

<script>
import Navbar from "@/components/menubar/Navbar";
import Sidebar from "@/components/menubar/Sidebar";

import { eventBus } from "@/main";
import { mapActions, mapGetters } from "vuex";
import { ROLES } from "@/constants/user";

export default {
  components: {
    Navbar,
    Sidebar,
  },
  data: () => ({
    treatmentAlert: new Audio(
      require("../../assets/sound/done-for-you-612.mp3")
    ),
    paymentAlert: new Audio(require("../../assets/sound/alert.mp3")),
    soundUnlocked: false,
    volume: 0.6,
  }),
  computed: {
    ...mapGetters({
      isAccessMenu: "moduleUser/getIsAccessMenu",
    }),
  },
  watch: {
    "$route.params.branchUrl": {
      immediate: true,
      handler(branchUrl) {
        const clinicUrl = this.$route.params.clinicUrl;
        if (clinicUrl && branchUrl && this.isAccessMenu([ROLES.ROLE_STOCK_STAFF, ROLES.ROLE_BRANCH_STOCK_MANAGER])) {
          this.fetchProductList({ clinicUrl, branchUrl }).catch(() => {});
        }
      },
    },
  },
  created() {
    document.body.addEventListener("click", this.unlockAudio, { once: true });
    document.body.addEventListener("touchstart", this.unlockAudio, {
      once: true,
    });
    eventBus.$on("playAudio", this.playAudio);
    eventBus.$on("adjustVolume", this.adjustVolume);

    this.volume = parseFloat(localStorage.getItem("volume") || "0.6");
  },
  beforeDestroy() {
    eventBus.$off("playAudio", this.playAudio);
    eventBus.$off("adjustVolume", this.adjustVolume);
  },
  methods: {
    ...mapActions({
      fetchProductList: "moduleProductInventory/fetchProductList",
    }),
    async unlockAudio() {
      if (this.soundUnlocked) return;

      try {
        const AudioCtx = window.AudioContext || window.webkitAudioContext;
        if (AudioCtx) {
          const ctx = new AudioCtx();
          await ctx.resume();
          ctx.close();
        }
      } catch (e) {
        // AudioContext not supported
      }

      this.volume = parseFloat(localStorage.getItem("volume") || "0.6");
      this.treatmentAlert.volume = this.volume;
      this.paymentAlert.volume = this.volume;
      this.treatmentAlert.load();
      this.paymentAlert.load();

      this.soundUnlocked = true;
      eventBus.$emit("soundUnlocked", true);
    },
    playAudio(e) {
      if (this.volume == 0) return;

      if (e === "waitingForTreatment") {
        this.treatmentAlert.currentTime = 0;
        this.treatmentAlert.play().catch(() => {});
      } else if (e === "waitingForPayment") {
        this.paymentAlert.currentTime = 0;
        this.paymentAlert.play().catch(() => {});
      }
    },
    adjustVolume(vol) {
      if (isNaN(vol)) return;
      this.volume = vol;
      this.treatmentAlert.volume = this.volume;
      this.paymentAlert.volume = this.volume;
      localStorage.setItem("volume", String(vol));
      if (this.volume == 0) return;

      if (this.$route.name === "QueueManage") {
        this.paymentAlert.currentTime = 0;
        this.paymentAlert.play().catch(() => {});
      } else {
        this.treatmentAlert.currentTime = 0;
        this.treatmentAlert.play().catch(() => {});
      }
    },
  },
};
</script>
 